export const EmptyBasketIcon = () => {
  return (
    <svg
      height="100px"
      width="100px"
      viewBox="0 0 14 14"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#546e7a"
          d="M2.14285707 5.85714284h-.57142858V3.28571423c0-.494.29857143-1.42857145 1.42857145-1.42857145h8.00000012c.494 0 1.42857145.35828572 1.42857145 1.71428574v2.28571432h-.57142858V3.57142852c0-1.1297143-.82200001-1.14285716-.85714287-1.14285716H2.99999994c-.80657144 0-.85542858.71542858-.85714287.85885716v2.56971432z"
        ></path>
        <path
          fill="#e91e63"
          d="M9.72428576 5.85714284C9.36000004 7.016 8.27885716 7.85714287 7 7.85714287c-1.27885716 0-2.36000004-.84114287-2.72428576-2.00000003H1.2857142l1.3774286 6.28571438h8.6734287l1.3777143-6.28571438H9.72428576zm-2.43857147 5.42857151h-.57142858v-1.14285716h.57142858v1.14285716zm0-1.71428574h-.57142858V8.42857145h.57142858v1.14285716zm1.42857145 1.71428574h-.57142858v-1.14285716h.57142858v1.14285716zm0-1.71428574h-.57142858V8.42857145h.57142858v1.14285716zm1.42857145 1.71428574h-.57142858v-1.14285716h.57142858v1.14285716zm0-1.71428574h-.57142858V8.42857145h.57142858v1.14285716zm-4.28571435 1.71428574h-.57142858v-1.14285716h.57142858v1.14285716zm0-1.71428574h-.57142858V8.42857145h.57142858v1.14285716zm-1.42857145 1.71428574h-.57142858v-1.14285716h.57142858v1.14285716zm0-1.71428574h-.57142858V8.42857145h.57142858v1.14285716z"
        ></path>
        <path
          fill="#ad1457"
          d="M12.42857151 5.57142855H8.61457145C8.37885716 6.23685713 7.74600001 6.71428571 7 6.71428571c-.74600001 0-1.37914288-.47742858-1.61457145-1.14285716H1.57142849c-.31542858 0-.57142858.256-.57142858.57142858v.28571429C.99999991 6.744 1.25599991 7 1.57142849 7h2.9811429C5.10942854 7.66714287 5.95085713 8.14285716 7 8.14285716c1.04914287 0 1.89057146-.4757143 2.4474286-1.14285716h2.98114291c.31542858 0 .57142858-.256.57142858-.57142858v-.28571429c0-.31542858-.256-.57142858-.57142858-.57142858z"
        ></path>
      </g>
    </svg>
  );
};

export const SearchIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      className="DocSearch-Search-Icon"
      viewBox="0 0 20 20"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export const BasketIcon = (props) => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#666666"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M3.5 4.5H5.05848C5.7542 4.5 6.10206 4.5 6.36395 4.68876C6.62584 4.87752 6.73584 5.20753 6.95585 5.86754L7.5 7.5"
          stroke="#313131"
          strokeLinecap="round"
        ></path>
        <path
          d="M17.5 17.5H8.05091C7.90471 17.5 7.83162 17.5 7.77616 17.4938C7.18857 17.428 6.78605 16.8695 6.90945 16.2913C6.92109 16.2367 6.94421 16.1674 6.99044 16.0287V16.0287C7.04177 15.8747 7.06743 15.7977 7.09579 15.7298C7.38607 15.0342 8.04277 14.5608 8.79448 14.5054C8.8679 14.5 8.94906 14.5 9.11137 14.5H14.5"
          stroke="#313131"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M14.1787 14.5H11.1376C9.85836 14.5 9.21875 14.5 8.71781 14.1697C8.21687 13.8394 7.96492 13.2515 7.461 12.0757L7.29218 11.6818C6.48269 9.79294 6.07794 8.84853 6.52255 8.17426C6.96715 7.5 7.99464 7.5 10.0496 7.5H15.3305C17.6295 7.5 18.779 7.5 19.2126 8.24711C19.6462 8.99422 19.0758 9.99229 17.9352 11.9884L17.6517 12.4846C17.0897 13.4679 16.8088 13.9596 16.3432 14.2298C15.8776 14.5 15.3113 14.5 14.1787 14.5Z"
          stroke="#313131"
          strokeLinecap="round"
        ></path>
        <circle cx="17" cy="20" r="1" fill="#313131"></circle>
        <circle cx="9" cy="20" r="1" fill="#313131"></circle>
      </g>
    </svg>
  );
};

export const HistoryIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      stroke={"#000000"}
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3.18 6.6a8.23 8.23 0 1112.93 9.94h0a8.23 8.23 0 01-11.63 0"></path>
        <path d="M6.44 7.25H2.55V3.36M10.45 6v5.6M10.45 11.6L13 13"></path>
      </g>
    </svg>
  );
};

export const DeleteIcon = ({ color, ...props }) => {
  const strokeColor = color || "#3688FF";
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M4 7H20"
          stroke={strokeColor}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
          stroke={strokeColor}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
          stroke={strokeColor}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  );
};

export const BackIcon = ({ onclick }) => {
  return (
    <svg
      width="30px"
      height="30px"
      fill="#0073ff"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      stroke="#0073fe"
      onClick={() => onclick()}
      style={{
        cursor: "pointer",
      }}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M74.656,56.818c3.895,3.729,5.788,8.795,5.788,15.491c0,1.104,0.896,2,2,2s2-0.885,2-1.989 c0-7.736-2.362-13.91-7.022-18.369C66.646,43.639,46.325,44.551,30,45.269c-2.28,0.101-4.461,0.211-6.499,0.28L38.428,30.62 c0.781-0.781,0.781-2.047,0-2.828s-2.048-0.781-2.828,0L17.479,45.915c-0.375,0.375-0.586,0.884-0.586,1.414 s0.211,1.039,0.586,1.414l18.123,18.12c0.391,0.391,0.902,0.586,1.414,0.586s1.024-0.195,1.415-0.586 c0.781-0.781,0.781-2.048,0-2.828L24.142,49.75c1.915-0.11,3.932-0.261,6.033-0.354C44.919,48.748,65.114,47.688,74.656,56.818z"></path>{" "}
        </g>
      </g>
    </svg>
  );
};

export const BackIcon2 = (props) => {
  return (
    <svg
      width="20"
      height="20"
      fill="#000000"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      enable-background="new 0 0 100 100"
      transform="rotate(90)"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <path d="M50.5,19.881c-1.104,0-2,0.896-2,2V72.17L33.193,56.609c-0.781-0.781-1.922-0.781-2.703,0 c-0.781,0.78-0.719,2.047,0.062,2.828l18.883,18.857c0.375,0.375,0.899,0.586,1.43,0.586s1.047-0.211,1.422-0.586l18.857-18.857 c0.781-0.781,0.783-2.048,0.002-2.828c-0.781-0.781-2.296-0.781-3.077,0L52.5,71.933V21.881C52.5,20.776,51.604,19.881,50.5,19.881 z"></path>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

export const ViewGridIconPrimary = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
      className="card-type-logo active"
      stroke="#c4cbdd"
      {...props}
    >
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        // opacity="0.8"
      >
        <path d="M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7M12 2v20M2 12h20"></path>
      </g>
    </svg>
  );
};

export const ViewGridIconSecondary = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
      className="card-type-logo"
      stroke="#c4cbdd"
      {...props}
    >
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        // opacity="0.8"
      >
        <path d="M22 15V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7h6c5 0 7-2 7-7M2 12h20"></path>
      </g>
    </svg>
  );
};

export const HomeIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 1024 1024"
      className="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M981.4 502.3c-9.1 0-18.3-2.9-26-8.9L539 171.7c-15.3-11.8-36.7-11.8-52 0L70.7 493.4c-18.6 14.4-45.4 10.9-59.7-7.7-14.4-18.6-11-45.4 7.7-59.7L435 104.3c46-35.5 110.2-35.5 156.1 0L1007.5 426c18.6 14.4 22 41.1 7.7 59.7-8.5 10.9-21.1 16.6-33.8 16.6z"
          fill="#5F6379"
        ></path>
        <path
          d="M810.4 981.3H215.7c-70.8 0-128.4-57.6-128.4-128.4V534.2c0-23.5 19.1-42.6 42.6-42.6s42.6 19.1 42.6 42.6v318.7c0 23.8 19.4 43.2 43.2 43.2h594.8c23.8 0 43.2-19.4 43.2-43.2V534.2c0-23.5 19.1-42.6 42.6-42.6s42.6 19.1 42.6 42.6v318.7c-0.1 70.8-57.7 128.4-128.5 128.4z"
          fill="#3688FF"
        ></path>
      </g>
    </svg>
  );
};

export const HomeIcon2 = (props) => {
  return (
    <svg
      width="20"
      height="20"
      fill="#313131"
      viewBox="-0.7 -0.7 36.40 36.40"
      data-name="Layer 2"
      id="bb0b4cad-0cac-4209-9e49-891b75d27240"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#313131"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M29.734,34.75H22.578a1.25,1.25,0,0,1-1.25-1.25V29.527a2.9,2.9,0,0,0-1.056-2.19,4.224,4.224,0,0,0-2.64-.987A4.127,4.127,0,0,0,14.7,27.477a3.19,3.19,0,0,0-1.025,2.275V33.5a1.25,1.25,0,0,1-1.25,1.25H5.266a3.136,3.136,0,0,1-3.132-3.132V13.324A5.949,5.949,0,0,1,4.589,8.518L14.9,1.065a4.494,4.494,0,0,1,5.2.018L30.432,8.625a5.949,5.949,0,0,1,2.434,4.79v18.2A3.136,3.136,0,0,1,29.734,34.75Zm-5.906-2.5h5.906a.632.632,0,0,0,.632-.632v-18.2a3.444,3.444,0,0,0-1.408-2.771L18.617,3.1a2.024,2.024,0,0,0-2.256-.007L6.054,10.544a3.441,3.441,0,0,0-1.42,2.78V31.618a.633.633,0,0,0,.632.632h5.906v-2.5a5.666,5.666,0,0,1,1.783-4.068A6.526,6.526,0,0,1,17.7,23.852a6.72,6.72,0,0,1,4.207,1.6,5.365,5.365,0,0,1,1.917,4.078Z"></path>
      </g>
    </svg>
  );
};

export const CategoryIcon = (props) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="-1.92 -1.92 27.84 27.84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(0)"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          opacity="0.34"
          d="M5 10H7C9 10 10 9 10 7V5C10 3 9 2 7 2H5C3 2 2 3 2 5V7C2 9 3 10 5 10Z"
          stroke="#3688FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z"
          stroke="#3688FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          opacity="0.34"
          d="M17 22H19C21 22 22 21 22 19V17C22 15 21 14 19 14H17C15 14 14 15 14 17V19C14 21 15 22 17 22Z"
          stroke="#3688FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17V19C2 21 3 22 5 22Z"
          stroke="#3688FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  );
};

export const UserIcon = (props) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <circle
          cx="12"
          cy="9"
          r="3"
          stroke="#5F6379"
          strokeWidth="1.5"
        ></circle>
        <path
          d="M17.9691 20C17.81 17.1085 16.9247 15 11.9999 15C7.07521 15 6.18991 17.1085 6.03076 20"
          stroke="#5F6379"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>
        <path
          d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
          stroke="#3688FF"
          stroke-width="1.5"
          stroke-linecap="round"
        ></path>
      </g>
    </svg>
  );
};

export const LeftArrowIcon = (props) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="-2.27 -2.27 80.34 80.34"
      xmlns="http://www.w3.org/2000/svg"
      fill="#3688FF"
      stroke="#3688FF"
      stroke-width="3.03212"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g
          id="Group_64"
          data-name="Group 64"
          transform="translate(-624.082 -383.588)"
        >
          <path
            id="Path_56"
            data-name="Path 56"
            d="M660.313,383.588a1.5,1.5,0,0,1,1.06,2.561l-33.556,33.56a2.528,2.528,0,0,0,0,3.564l33.556,33.558a1.5,1.5,0,0,1-2.121,2.121L625.7,425.394a5.527,5.527,0,0,1,0-7.807l33.556-33.559A1.5,1.5,0,0,1,660.313,383.588Z"
            fill="#3688FF"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const CompareIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 110.379 122.879"
      enableBackground="new 0 0 110.379 122.879"
      fill="#5F6379"
      {...props}
    >
      <g>
        <path d="M41.759,15.103l-0.003,0.174h35.077c0.089,0,0.176,0.005,0.262,0.016c3.325,0.267,6.487,0.843,9.461,1.78l0.008,0.003 c3.021,0.95,5.853,2.286,8.469,4.062c1.827,1.239,3.404,2.59,4.768,4.033c1.363,1.441,2.527,2.988,3.532,4.618 c1.557,2.527,2.806,5.523,3.803,8.643c1.228,3.84,2.076,7.868,2.65,11.415c0.229,1.417,0.398,2.801,0.449,4.005 c0.059,1.382-0.049,2.591-0.399,3.472c-0.206,0.519-0.473,0.962-0.801,1.326c-0.378,0.421-0.831,0.738-1.357,0.949 c-3.667,1.468-6.662-2.08-8.46-4.211l-0.004,0.003l-0.331-0.393c-3.032-3.536-6.757-6.041-11.022-7.732 c-4.333-1.718-9.252-2.611-14.598-2.903l-31.771,0.002l0.015,0.271l0,9.127c0,0.086-0.005,0.17-0.015,0.253 c-0.089,2.142-0.799,3.66-2.136,4.544c-1.34,0.887-3.091,0.97-5.257,0.24c-0.235-0.079-0.448-0.196-0.632-0.341 c-10.452-8.2-20.905-16.397-31.353-24.602l-0.147-0.127C0.23,32.152-0.25,30.51,0.114,28.867c0.322-1.452,1.333-2.69,2.692-3.761 l28.87-22.727c1.25-0.984,2.562-1.749,3.797-2.119c1.107-0.332,2.187-0.362,3.181-0.002c1.084,0.393,1.95,1.188,2.502,2.475 c0.393,0.917,0.615,2.098,0.615,3.584v8.556C41.772,14.951,41.768,15.028,41.759,15.103L41.759,15.103z M68.619,107.776 l0.003-0.175H33.545c-0.088,0-0.176-0.005-0.261-0.016c-3.325-0.267-6.488-0.843-9.461-1.78l-0.007-0.003 c-3.021-0.949-5.853-2.285-8.469-4.061c-1.839-1.248-3.423-2.607-4.791-4.059c-1.376-1.459-2.546-3.018-3.551-4.656 c-1.622-2.646-2.98-6.021-4.055-9.54c-1.276-4.181-2.157-8.56-2.607-12.145c-0.133-1.063-0.214-2.102-0.213-3.053 c0.001-1.071,0.125-2.011,0.414-2.735c0.202-0.506,0.467-0.945,0.798-1.314c0.385-0.43,0.838-0.751,1.36-0.961 c3.667-1.468,6.663,2.08,8.46,4.212l0.004-0.003l0.332,0.393c3.032,3.536,6.756,6.041,11.022,7.731 c4.333,1.718,9.252,2.611,14.598,2.903l31.77-0.003l-0.015-0.271l-0.001-9.127c0-0.086,0.006-0.17,0.016-0.253 c0.089-2.143,0.799-3.661,2.136-4.545c1.341-0.887,3.091-0.97,5.257-0.239c0.235,0.078,0.447,0.195,0.632,0.341l31.354,24.602 l0.147,0.127c1.736,1.58,2.217,3.224,1.853,4.865c-0.322,1.452-1.333,2.69-2.692,3.761L78.702,120.5 c-1.25,0.984-2.562,1.748-3.797,2.118c-1.107,0.332-2.187,0.362-3.182,0.003c-1.084-0.393-1.95-1.188-2.502-2.476 c-0.393-0.917-0.615-2.098-0.615-3.584v-8.556C68.606,107.928,68.611,107.852,68.619,107.776L68.619,107.776z M72.229,105.025 c0.465,0.773,0.603,1.688,0.592,2.831l0.006,0.149v8.556c0,0.904,0.097,1.535,0.269,1.936c0.051,0.118,0.057,0.165,0.063,0.167 c0.082,0.03,0.274-0.004,0.544-0.084c0.699-0.209,1.534-0.716,2.396-1.394l28.869-22.728c0.652-0.514,1.111-0.986,1.193-1.354 c0.034-0.157-0.121-0.416-0.555-0.815L74.6,67.956c-0.664-0.199-1.081-0.242-1.253-0.128c-0.146,0.097-0.233,0.486-0.259,1.165 l0.004,9.172c0.075,1.035-0.088,1.955-0.538,2.734c-0.531,0.924-1.354,1.532-2.516,1.771c-0.164,0.041-0.335,0.063-0.512,0.063 H37.117v-0.005l-0.107-0.003c-5.816-0.309-11.215-1.293-16.04-3.205c-4.89-1.938-9.166-4.817-12.66-8.889l-0.36-0.423l0.004-0.004 l-0.004-0.005c-0.996-1.181-2.616-3.102-3.517-3.049c-0.069,0.218-0.1,0.616-0.101,1.14c0,0.683,0.074,1.562,0.197,2.542 c0.428,3.417,1.255,7.547,2.442,11.435c0.975,3.191,2.191,6.228,3.626,8.568c0.854,1.394,1.851,2.721,3.023,3.964 c1.179,1.249,2.528,2.41,4.083,3.465c2.238,1.519,4.708,2.677,7.38,3.52c2.655,0.839,5.505,1.355,8.521,1.599h35.392v0.009 C70.569,103.392,71.57,103.931,72.229,105.025L72.229,105.025z M38.149,17.854c-0.466-0.772-0.604-1.688-0.592-2.831l-0.005-0.149 V6.317c0-0.904-0.098-1.535-0.269-1.936c-0.051-0.118-0.057-0.165-0.063-0.167c-0.083-0.03-0.274,0.004-0.544,0.084 c-0.699,0.21-1.535,0.716-2.396,1.394L5.411,28.419c-0.652,0.514-1.111,0.987-1.192,1.354c-0.035,0.158,0.121,0.416,0.555,0.815 c10.332,8.115,20.671,16.223,31.006,24.334c0.664,0.2,1.081,0.242,1.251,0.128c0.147-0.097,0.234-0.487,0.259-1.165l-0.003-9.172 c-0.075-1.036,0.088-1.956,0.538-2.735c0.532-0.924,1.355-1.532,2.515-1.771c0.164-0.041,0.335-0.063,0.513-0.063h32.409v0.005 l0.107,0.003c5.815,0.308,11.215,1.293,16.039,3.206c4.89,1.938,9.166,4.817,12.66,8.889l0.359,0.423l-0.004,0.003l0.004,0.004 c0.996,1.181,2.616,3.103,3.517,3.049c0.1-0.305,0.12-0.916,0.087-1.712c-0.043-1.017-0.193-2.237-0.4-3.511 c-0.547-3.382-1.351-7.204-2.502-10.805c-0.898-2.81-2.01-5.487-3.375-7.703c-0.851-1.381-1.846-2.7-3.02-3.942 c-1.173-1.24-2.516-2.393-4.06-3.44c-2.238-1.519-4.708-2.677-7.38-3.52c-2.655-0.839-5.505-1.355-8.521-1.599H41.382v-0.008 C39.809,19.487,38.809,18.949,38.149,17.854L38.149,17.854z" />
      </g>
    </svg>
  );
};

export const GiftIcon = (props) => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      className="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#5F6379"
      stroke="#5F6379"
      strokeWidth="15.36"
      width="35"
      height="35"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M900.5 370.6v92.6c0 9.4-5.9 17.8-14.8 20.9l-151.9 52.2V396.5l-101.9-33.1 105.6-45.6c11.9-6.1 21.9-12 30-17.8l117.3 48c9.4 3.5 15.7 12.6 15.7 22.6z"
          fill="#ffffff"
        ></path>
        <path d="M887.1 492.2v4.4l-12.3 4.2v-8.6z" fill="#3688FF"></path>
        <path d="M874.8 500.8v262.3l-141 54V549.2z" fill="#ffffff"></path>
        <path
          d="M912.8 370.6v92.6c0 14.7-9.3 27.8-23.2 32.6l-2.5 0.9v-4.4h-12.3v8.6l-141 48.4v-13L885.6 484c8.9-3.1 14.8-11.5 14.8-20.9v-92.6c0-10-6.3-19-15.7-22.5l-117.3-48c4.2-2.8 7.9-5.7 11.1-8.6l110.6 45.2c14.2 5.1 23.7 18.8 23.7 34zM771.9 213.5c12.8 17.8 17.5 32.5 14.6 44.9-2.1 9.1-8.4 17.8-19.5 26.8-8.6 6.9-20.1 14-34.8 21.5l-116.4 50.1c-3.8-20.9-24.2-38.3-53-47.2l92.2-101c14.1-19.3 33.3-30.5 54.5-31.5 17.8-1 35.6 6.1 46.2 18l16.2 18.4z"
          fill="#3688FF"
        ></path>
        <path
          d="M769 287.5l9.6 4c-3.2 3-6.9 5.8-11.1 8.6l-3.1-1.2 4.6-11.4zM733.8 817.1v6.2h-12.4v-1.5zM733.8 536.3v12.9l-3.1 1.2-4.1-11.7zM721.4 405.5v416.3L635 854.9v-419l-58.4-22.4c21.5-9.8 36.2-24.8 39.3-42.4l105.5 34.4zM635 854.9v8.9h-12.4v-4.2z"
          fill="#3688FF"
        ></path>
        <path
          d="M635 435.9v419l-12.3 4.7V600.2l8.4-3.1-4.3-11.6-4.1 1.5V444.3l-63.8-24.5c6.3-1.6 12.3-3.8 17.8-6.3l58.3 22.4z"
          fill="#3688FF"
        ></path>
        <path
          d="M764.4 298.8l3.1 1.2c-8.2 5.8-18.2 11.7-30 17.8l-105.6 45.6 101.9 33.1v139.8l-7.2 2.5 4.1 11.6 3.1-1.1v267.8l-12.3 4.7V405.5l-105.6-34.3c0.4-2.2 0.6-4.7 0.6-7 0-2.5-0.2-4.9-0.7-7.3l116.4-50.1c14.7-7.5 26.2-14.6 34.8-21.5l2 2.2-4.6 11.3zM626.7 585.5l4.3 11.7-8.4 3V587z"
          fill="#3688FF"
        ></path>
        <path
          d="M622.6 600.2v259.3l-110 42.1-123-47.4V588.5L497 632.7c6.1 2.6 12.3 3.8 18.8 3.8 5.4 0 11-1 16.3-2.8l90.5-33.5z"
          fill="#ffffff"
        ></path>
        <path
          d="M622.6 444.3V587l-94.7 35.1c-8.5 3.1-17.7 2.8-26.1-0.7l-112.2-46.1V440.9l65.4-29.6c17 8.6 38.9 13.8 63.2 13.8 14.6 0 28.2-1.9 40.5-5.3l63.9 24.5z"
          fill="#ffffff"
        ></path>
        <path d="M621.4 233.2l-4.7 11.4-8-3.3 8.7-9.7z" fill="#3688FF"></path>
        <path
          d="M781.4 205.8c15.6 21.2 21 39.3 17 55.6-2.6 10.6-8.9 20.4-19.9 30l-9.6-4-2-2.2c11.1-9 17.4-17.7 19.5-26.8 3-12.5-1.7-27.2-14.6-44.9l-16.3-18.3c-10.6-12-28.4-19-46.2-18-21.1 1-40.4 12.2-54.5 31.5l-92.2 101c-4.3-1.4-8.8-2.5-13.5-3.3l59.4-65.1 8 3.3 4.7-11.4-4-1.6 28-30.7c15.8-21.9 38.5-34.9 63.3-36.1 21.7-1.1 42.7 7.2 55.9 22.1l17 18.9zM615.7 356.9c0.5 2.3 0.7 4.8 0.7 7.3 0 2.3-0.2 4.8-0.6 7l-7.4-2.5-0.1-8.8 4.1-1.6 3.3-1.4z"
          fill="#3688FF"
        ></path>
        <path
          d="M608.7 241.3l-59.4 65.1c-9.6-2.1-20.1-3.1-31-3.1-9.3 0-18.2 0.7-26.7 2.2l-55.4-71.7 70-24.7c8.5-3.3 17.8-3.2 26.2 0.4l76.3 31.8z"
          fill="#ffffff"
        ></path>
        <path
          d="M561.1 407.6l15.4 5.9c-5.4 2.5-11.5 4.7-17.8 6.3l-2.1-0.7 4.5-11.5zM562.7 309.7l-6.8 7.5-9-8.3 2.3-2.6c4.8 0.9 9.2 2 13.5 3.4zM518.3 315.6c46.6 0 85.8 22.2 85.8 48.5 0 17.8-17.7 33.6-43.5 42.1-12.5 4.2-27 6.5-42.4 6.5-46.7 0-85.9-22.2-85.9-48.7 0-4.6 1.2-9 3.5-13.3 10.5-19.9 43.9-35.1 82.5-35.1zM506.2 209l-70 24.7-7.9-10.2 73.6-25.9c11.2-4.4 23.8-4.3 35.3 0.4l80.3 33.7-8.8 9.6-76.3-31.9c-8.4-3.6-17.7-3.7-26.2-0.4zM501.9 621.4c8.4 3.6 17.5 3.8 26.1 0.7l94.7-35.1v13.2l-90.5 33.5c-5.3 1.9-10.9 2.8-16.3 2.8-6.4 0-12.7-1.2-18.8-3.8l-107.4-44.2v-13.2l112.2 46.1zM491.6 305.5l0.1 0.1-9.8 7.5-3.7-4.8c4.4-1.1 8.8-2.1 13.4-2.8z"
          fill="#3688FF"
        ></path>
        <path
          d="M384.3 186.8l94 121.5c-22.7 6.2-40.8 17.4-50.5 31.6l-1.6 0.7-118.4-57.4a43.9 43.9 0 0 1-24.5-33.7c-2.1-14.6 3.5-29.1 14.6-39l33.1-28.9c7.7-6.8 17.5-10 27.8-9 10.2 1 19.2 6.1 25.5 14.2zM442.5 403.4l8.5-3.8 5.1 11.2-1 0.5c-4.6-2.5-8.8-5.1-12.6-7.9z"
          fill="#3688FF"
        ></path>
        <path
          d="M482 313.1l9.8-7.5-0.1-0.1c8.5-1.5 17.4-2.2 26.7-2.2 10.9 0 21.4 1 31 3.1l-2.3 2.6 9 8.3 6.8-7.5c28.8 8.9 49.1 26.3 53 47.2l-3.3 1.5-4.1 1.6 0.1 8.8 7.4 2.5c-3.1 17.5-17.8 32.6-39.3 42.4l-15.4-5.9-0.5-1.4c25.8-8.5 43.5-24.3 43.5-42.1 0-26.3-39.3-48.5-85.8-48.5-38.5 0-72 15.2-82.5 35.2l-1.1-0.5-4.9-11.2-2 0.9c9.8-14.2 27.8-25.4 50.5-31.6l3.5 4.4zM442.5 403.4L377.3 433v416.4l-80.8-31.1V412.2l124.2-55.6c-0.5 2.5-0.7 4.9-0.7 7.5 0 15.1 8.4 28.8 22.5 39.3zM428.3 223.5l7.9 10.2-8.1 2.9-4-11.6z"
          fill="#3688FF"
        ></path>
        <path
          d="M451 399.6l-8.5 3.8c-14.1-10.5-22.5-24.2-22.5-39.3 0-2.6 0.2-5.1 0.7-7.5l14-6.3 1.1 0.5c-2.2 4.3-3.5 8.8-3.5 13.3 0 26.4 39.3 48.7 85.9 48.7 15.3 0 29.9-2.3 42.4-6.5l0.5 1.4-4.4 11.5 2.1 0.7c-12.3 3.5-25.9 5.3-40.5 5.3-24.3 0-46.2-5.2-63.2-13.8l1-0.5-5.1-11.3zM428.7 341.9l-5.3 11.1-1.6-0.7c1.1-4 3-7.7 5.2-11.2l1.7 0.8z"
          fill="#3688FF"
        ></path>
        <path
          d="M426.2 340.7l1.6-0.7c-0.2 0.4-0.5 0.7-0.7 1.1l-0.9-0.4z"
          fill="#ffffff"
        ></path>
        <path
          d="M426.2 340.7l0.9 0.4c-2.2 3.6-4.1 7.3-5.2 11.2l-10.4-5.1 14.7-6.5z"
          fill="#3688FF"
        ></path>
        <path
          d="M429.7 339.1l4.9 11.2-14 6.3c0.2-1.5 0.6-3 1.1-4.3l1.6 0.7 5.3-11.1-1.6-0.9c0.2-0.4 0.5-0.7 0.7-1.1l2-0.8zM389.6 854.3v4.2h-12.3v-9.1z"
          fill="#3688FF"
        ></path>
        <path
          d="M389.6 588.5v265.8l-12.3-4.9V584.7h2.9zM389.6 575.3v13.2l-9.4-3.8 4.7-11.4z"
          fill="#3688FF"
        ></path>
        <path
          d="M377.3 584.7V433l65.2-29.6c3.8 2.8 8 5.4 12.6 7.9l-65.4 29.6v134.4l-4.7-2-4.7 11.4h-3zM296.5 818.3v6.9h-12.4v-11.7z"
          fill="#3688FF"
        ></path>
        <path
          d="M296.5 412.2v406.1l-12.3-4.8v-266l4.3 1.4 3.7-11.7-8-2.5V404.1l127.3-56.9 10.4 5.1c-0.5 1.4-0.9 2.8-1.1 4.3l-124.3 55.6zM887.1 496.6v274.9L512.6 914.9l-228.9-88.3 0.4-1.4h12.4v-6.9l80.8 31.1v9.1h12.3v-4.2l123 47.4 110-42.1v4.2H635v-8.9l86.4-33.1v1.5h12.4v-6.2l141-54V500.8z"
          fill="#3688FF"
        ></path>
        <path
          d="M292.5 289.4l-0.6-1.6c3.2 2.7 6.7 4.8 10.4 6.7l109.2 52.7-127.3 56.9v130.5L164 496.9v-0.2h-0.7l-28.3-8.9c-7.4-2.2-12.5-9-12.5-16.8V369.7c0-8.5 5.1-16.1 12.8-19.3l157.2-61z"
          fill="#ffffff"
        ></path>
        <path
          d="M292.2 537.1l-3.7 11.8-4.4-1.4v-12.8zM288.1 277.9l3.8 9.9c-3.1-2.3-5.9-5.1-8.4-8.2l4.6-1.7z"
          fill="#3688FF"
        ></path>
        <path
          d="M284.1 547.5v266l-101.5-39.1c-11.1-4.3-18.6-15.2-18.6-27.2V509.9l120.1 37.6z"
          fill="#ffffff"
        ></path>
        <path
          d="M284.1 534.7v12.8L164 509.9v-13zM270.9 251.3c-2.5-18.8 4.4-37.5 18.8-50l33.1-28.9c10.2-9.1 23.5-13.3 37.2-12 13.6 1.2 25.7 8 34.1 18.9l34.2 44.2-4.2 1.5 4.1 11.6 8-2.8 55.4 71.7c-4.6 0.7-9 1.7-13.3 2.8l-94-121.5c-6.3-8.2-15.3-13.2-25.6-14.2-10.2-1-20.1 2.2-27.8 9l-33.1 28.9c-11.1 9.9-16.7 24.5-14.6 39 2 14.7 11.1 27.3 24.5 33.7l118.4 57.4-14.7 6.5-109.2-52.7c-3.7-1.9-7.2-4-10.4-6.7l-3.8-9.9-4.6 1.7c-6.5-7.7-11-17.6-12.5-28.2zM164 496.9v13l-12.4-3.9v-9.4h11.7z"
          fill="#3688FF"
        ></path>
        <path d="M164 496.6v0.3l-0.7-0.3z" fill="#ffffff"></path>
        <path
          d="M151.6 747.2V506l12.3 3.8v237.3c0 12 7.5 22.8 18.6 27.2L284 813.4v11.7l-0.5 1.4L178 785.7c-15.6-5.9-26.4-21.5-26.4-38.5z"
          fill="#3688FF"
        ></path>
        <path
          d="M110.2 369.7c0-13.5 8.2-25.6 20.6-30.7l152.8-59.3c2.5 3.1 5.3 5.8 8.4 8.2l0.6 1.6-157.2 61c-7.8 3.2-12.8 10.7-12.8 19.3V471c0 7.8 5.1 14.6 12.5 16.8l28.3 8.9h-11.6v9.4l-20.4-6.4c-12.6-4-21.1-15.4-21.1-28.6V369.7z"
          fill="#3688FF"
        ></path>
      </g>
    </svg>
  );
};

export const ClearIcon = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
          stroke="#3688FF"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>
        <path
          d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
          stroke="#3688FF"
          strokeWidth="1.5"
          strokeLinecap="round"
        ></path>
      </g>
    </svg>
  );
};

export const UnCheckedIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <rect
          fill="#f9fbff"
          strokeWidth="1"
          stroke="#868c8f"
          x="0.5"
          y="0.5"
          width="23"
          height="23"
          rx="5.5"
        ></rect>
      </g>
    </svg>
  );
};

export const CheckedIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <rect
          fill="#007bff"
          strokeWidth="1"
          stroke="#007bff"
          x="0.5"
          y="0.5"
          width="23"
          height="23"
          rx="5.5"
        ></rect>
        <path
          d="M6 12l4 4 8-8"
          fill="none"
          stroke="#ffffff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  );
};

export const FilterExpandArrow = (props) => {
  const { color } = props;
  return (
    <svg
      viewBox="-19.04 0 75.804 75.804"
      xmlns="http://www.w3.org/2000/svg"
      fill={color || "#000000"}
      width="15"
      height="15"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color || "#000000"}
        strokeWidth="0.75804"
      >
        <g
          id="Group_65"
          data-name="Group 65"
          transform="translate(-831.568 -384.448)"
        >
          <path
            id="Path_57"
            data-name="Path 57"
            d="M833.068,460.252a1.5,1.5,0,0,1-1.061-2.561l33.557-33.56a2.53,2.53,0,0,0,0-3.564l-33.557-33.558a1.5,1.5,0,0,1,2.122-2.121l33.556,33.558a5.53,5.53,0,0,1,0,7.807l-33.557,33.56A1.5,1.5,0,0,1,833.068,460.252Z"
            fill={color || "#000000"}
          ></path>
        </g>
      </g>
      <g id="SVGRepo_iconCarrier">
        <g
          id="Group_65"
          data-name="Group 65"
          transform="translate(-831.568 -384.448)"
        >
          <path
            id="Path_57"
            data-name="Path 57"
            d="M833.068,460.252a1.5,1.5,0,0,1-1.061-2.561l33.557-33.56a2.53,2.53,0,0,0,0-3.564l-33.557-33.558a1.5,1.5,0,0,1,2.122-2.121l33.556,33.558a5.53,5.53,0,0,1,0,7.807l-33.557,33.56A1.5,1.5,0,0,1,833.068,460.252Z"
            fill={color || "#000000"}
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const FilterIcon = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={"20px"}
      height={"20px"}
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M5 12L5 4" stroke="#222222" strokeLinecap="round"></path>
        <path d="M19 20L19 17" stroke="#222222" strokeLinecap="round"></path>
        <path d="M5 20L5 16" stroke="#222222" strokeLinecap="round"></path>
        <path d="M19 13L19 4" stroke="#222222" strokeLinecap="round"></path>
        <path d="M12 7L12 4" stroke="#222222" strokeLinecap="round"></path>
        <path d="M12 20L12 11" stroke="#222222" strokeLinecap="round"></path>
        <circle
          cx="5"
          cy="14"
          r="2"
          stroke="#222222"
          stroke-linecap="round"
        ></circle>
        <circle
          cx="12"
          cy="9"
          r="2"
          stroke="#222222"
          stroke-linecap="round"
        ></circle>
        <circle
          cx="19"
          cy="15"
          r="2"
          stroke="#222222"
          stroke-linecap="round"
        ></circle>
      </g>
    </svg>
  );
};

export const BasketWithPlusIcon = (props) => {
  return (
    <div style={{ position: "relative", width: "25px", height: "25px" }}>
      <svg
        width="25px"
        height="25px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#666666"
        {...props}
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="M3.5 4.5H5.05848C5.7542 4.5 6.10206 4.5 6.36395 4.68876C6.62584 4.87752 6.73584 5.20753 6.95585 5.86754L7.5 7.5"
            stroke="#313131"
            strokeLinecap="round"
          ></path>
          <path
            d="M17.5 17.5H8.05091C7.90471 17.5 7.83162 17.5 7.77616 17.4938C7.18857 17.428 6.78605 16.8695 6.90945 16.2913C6.92109 16.2367 6.94421 16.1674 6.99044 16.0287V16.0287C7.04177 15.8747 7.06743 15.7977 7.09579 15.7298C7.38607 15.0342 8.04277 14.5608 8.79448 14.5054C8.8679 14.5 8.94906 14.5 9.11137 14.5H14.5"
            stroke="#313131"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M14.1787 14.5H11.1376C9.85836 14.5 9.21875 14.5 8.71781 14.1697C8.21687 13.8394 7.96492 13.2515 7.461 12.0757L7.29218 11.6818C6.48269 9.79294 6.07794 8.84853 6.52255 8.17426C6.96715 7.5 7.99464 7.5 10.0496 7.5H15.3305C17.6295 7.5 18.779 7.5 19.2126 8.24711C19.6462 8.99422 19.0758 9.99229 17.9352 11.9884L17.6517 12.4846C17.0897 13.4679 16.8088 13.9596 16.3432 14.2298C15.8776 14.5 15.3113 14.5 14.1787 14.5Z"
            stroke="#313131"
            strokeLinecap="round"
          ></path>
          <circle cx="17" cy="20" r="1" fill="#313131"></circle>
          <circle cx="9" cy="20" r="1" fill="#313131"></circle>
        </g>
      </svg>
      <svg
        width="12px" // size of the plus icon
        height="12px" // size of the plus icon
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: "absolute",
          top: "-2px", // position from the top edge
          right: "-6px", // position from the right edge
        }}
      >
        <path
          d="M12 2V22"
          stroke="#313131"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
        {/* bolder line */}
        <path
          d="M2 12H22"
          stroke="#313131"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
        {/* bolder line */}
      </svg>
    </div>
  );
};

export const UserProfileSvg = (props) => {
  return (
    <svg
      height="45px"
      width="45px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="#000000"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          style={{ fill: "#FFFFFF" }}
          d="M256,508C117.04,508,4,394.96,4,256S117.04,4,256,4s252,113.04,252,252S394.96,508,256,508z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M256,8c136.752,0,248,111.248,248,248S392.752,504,256,504S8,392.752,8,256S119.248,8,256,8 M256,0 C114.608,0,0,114.608,0,256s114.608,256,256,256s256-114.608,256-256S397.392,0,256,0L256,0z"
        ></path>
        <g>
          <ellipse
            style={{ fill: "#3688FF" }}
            cx="256"
            cy="175.648"
            rx="61.712"
            ry="60.48"
          ></ellipse>
          <path
            style={{ fill: "#3688FF" }}
            d="M362.592,360.624c0-57.696-47.728-104.464-106.592-104.464s-106.592,46.768-106.592,104.464H362.592 z"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const CloseIcon = (props) => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 1024 1024"
      fill="#000000"
      className="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M176.662 817.173c-8.19 8.471-7.96 21.977 0.51 30.165 8.472 8.19 21.978 7.96 30.166-0.51l618.667-640c8.189-8.472 7.96-21.978-0.511-30.166-8.471-8.19-21.977-7.96-30.166 0.51l-618.666 640z"
          fill=""
        ></path>
        <path
          d="M795.328 846.827c8.19 8.471 21.695 8.7 30.166 0.511 8.471-8.188 8.7-21.694 0.511-30.165l-618.667-640c-8.188-8.471-21.694-8.7-30.165-0.511-8.471 8.188-8.7 21.694-0.511 30.165l618.666 640z"
          fill=""
        ></path>
      </g>
    </svg>
  );
};

export const MonitorSvg = (props) => {
  return (
    <svg
      height={20}
      width={20}
      viewBox="0 0 1024 1024"
      className="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M628.9 935.1L213.8 797.8l165-130 389.1 107.3z"
          fill="#A1BBC6"
        ></path>
        <path d="M767.9 775.1V788l-139 161.3v-14.2z" fill="#678289"></path>
        <path d="M628.9 949.3v-14.2L213.8 797.8v13.9z" fill="#BACCD3"></path>
        <path
          d="M600.1 729l157.2 43.3-117 13.4-39.5 19.1z"
          fill="#8EA8AF"
        ></path>
        <path
          d="M404.9 583.2l31.4 173.6 164.5 48-28.9-170.6z"
          fill="#7C99A3"
        ></path>
        <path d="M598.6 700l16.5 91-14.3 13.8L581.1 703z" fill="#678289"></path>
        <path d="M884 792.4L114 584.9v-491l770 162.5z" fill="#37BBEF"></path>
        <path d="M909 751.9l-25 40.5v-536l26-27.5z" fill="#678289"></path>
        <path
          d="M910 228.9L151.4 74.7 114 93.9l770 162.5z"
          fill="#A1BBC6"
        ></path>
        <path
          d="M114 93.9v491l770 207.5v-536L114 93.9z m755.6 616.5l-746-192.5V106l746 161v443.4z"
          fill="#BACCD3"
        ></path>
        <path d="M850.8 724.5v17l-39.5-11V714z" fill="#FFFFFF"></path>
        <path d="M846 727.3v8.9l-29.9-8.4v-8.5z" fill="#113B42"></path>
        <path d="M787.6 708v17l-39.5-11v-16.5z" fill="#FFFFFF"></path>
        <path d="M784.1 711.1v9.5l-32.5-9.1v-9z" fill="#113B42"></path>
        <path
          d="M853.3 703.6l-213-485.8 229.1 49.3-0.1 441z"
          fill="#3ED6FF"
        ></path>
        <path d="M124.9 106v412.8" fill="#3ED6FF"></path>
      </g>
    </svg>
  );
};

export const DownArrow = (props) => {
  const { color } = props;
  return (
    <svg
      height={"20px"}
      width={"20px"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M7 10L12 15L17 10"
          stroke={color || "#000000"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </g>
    </svg>
  );
};
